import React from 'react'
import hyphen from 'hyphen/da/index.js'

const { hyphenateSync } = hyphen

interface HyphenatedTextProps {
  text?: string
  minWordLength?: number
}

/**
 * Render a hyphenated text, so it wraps nicely in the browser.
 * @param text
 * @param minWordLength
 * @constructor
 */
export function HyphenatedText({ text, minWordLength }: HyphenatedTextProps) {
  return React.useMemo(
    () => (
      <>
        {text
          ? hyphenateSync(text, minWordLength ? { minWordLength } : undefined)
          : null}
      </>
    ),
    [text, minWordLength],
  )
}
